
import React from 'react';
import {Stepper} from '../../../dist/src/index';
import {AdvanceButton, ReverseButton, VerticalStepper} from '../../../react-toolbox';
import {PageOne, PageTwo, PageThree} from '../../src/example-helpers';


const store = {}
export const attributes = {"title":"Vertical Stepper"};
export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {
    return (
      <div>
        {(store.example = <Stepper pages={[
  {
    title: 'Step one',
    status: 'done',
    component: PageOne,
  },
  {
    title: 'Step two',
    status: 'alert',
    component: PageTwo,
  },
  {
    title: 'Step three',
    component: PageThree,
  },
]}>
  <VerticalStepper />
</Stepper>
, null)}<h3>Vertical Stepper</h3>
<p>Depending on the design it's sometimes not possible or inconvenient to break
the stepper down into composable components. The Vertical Stepper is an example
of that which renders the view and the buttons on different locations while you
navigate though it.</p>
<p>The vertical stepper also support the status property on pages which can be used
to help the user know their progress through the stepper.</p>
<h6>Demo</h6>

    <div className="example">
      <div className="run"><div>
  {store.example}
</div>
</div>
    </div>
  <h6>Code</h6>

    <div className="example">
      <div className="source">
        <pre><code className="language-jsx">
          <span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>Stepper</span> <span className="token attr-name">pages</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">[</span>{"\n"}  <span className="token punctuation">{"{"}</span>{"\n"}    title<span className="token punctuation">:</span> <span className="token string">'Step one'</span><span className="token punctuation">,</span>{"\n"}    status<span className="token punctuation">:</span> <span className="token string">'done'</span><span className="token punctuation">,</span>{"\n"}    component<span className="token punctuation">:</span> PageOne<span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"{"}</span>{"\n"}    title<span className="token punctuation">:</span> <span className="token string">'Step two'</span><span className="token punctuation">,</span>{"\n"}    status<span className="token punctuation">:</span> <span className="token string">'alert'</span><span className="token punctuation">,</span>{"\n"}    component<span className="token punctuation">:</span> PageTwo<span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"{"}</span>{"\n"}    title<span className="token punctuation">:</span> <span className="token string">'Step three'</span><span className="token punctuation">,</span>{"\n"}    component<span className="token punctuation">:</span> PageThree<span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}<span className="token punctuation">]</span><span className="token punctuation">{"}"}</span></span><span className="token punctuation">></span></span>{"\n"}  <span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>VerticalStepper</span> <span className="token punctuation">/></span></span>{"\n"}<span className="token tag"><span className="token tag"><span className="token punctuation">&lt;/</span>Stepper</span><span className="token punctuation">></span></span>{"\n"}
        </code></pre>
      </div>
    </div>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./docs/pages/Examples/04-vertical-stepper.md